import React, { Fragment } from "react";
import { withTranslation } from "react-i18next";
import { Card, CardBody, Col, Row } from "reactstrap";
import ReactTable from "react-table";

class StatisticsOriginTable extends React.Component {

  render() {
    const { t, i18n, data } = this.props;
    
    const tableData = data.flatMap(periodEntry => {
      const period = periodEntry.period;
      const details = periodEntry.details || [];
      return details.map(detail => ({
        period: period,
        origin: detail.origin,
        total: detail.total,
        date: detail.date
      }));
    });
    
    return (
      <Fragment>
        <Card className="main-card mb-3">
          <CardBody>
            <ReactTable
              columns={[
                {
                  Header: t("statistics.origin.period"),
                  accessor: 'period'
                },
                {
                  Header: t("statistics.origin.origin"),
                  accessor: 'origin'
                },
                {
                  Header: t("statistics.origin.total"),
                  accessor: 'total'
                },
                {
                  Header: t("statistics.origin.date"),
                  accessor: 'date',
                  Cell: (prop) => {
                    let date = '';
                    if (prop.value) {
                      date = new Date(prop.value).toLocaleDateString()
                    }
                    return (
                      <div className="d-block w-100 text-center">
                        {date}
                      </div>
                    )
                  }
                },
              ]}
              data={tableData}
              defaultPageSize={10}
              className="-striped -highlight"
              getTrProps={(state, rowInfo) => {
                if (rowInfo && rowInfo.row) {
                  return {
                    onClick: (e) => {
                      if (e.target.tagName.toLowerCase() === 'button') {
                        return; // Ignore clicks on buttons
                      }
                    },
                    style: {
                      cursor: 'pointer'
                    }
                  }
                }
                return {}
              }} />
          </CardBody>
        </Card>
      </Fragment>
    )
  }
}

export default withTranslation()(StatisticsOriginTable);